import { useState } from 'react';
import { Ruler } from 'lucide-react';
import { scheduleCrmLeadMeasurement } from '../../../api';
import { AdminMeasurementIntakeFields } from '../AdminMeasurementIntakeFields';

type Props = {
  leadId: number;
  onScheduled: (measurementId: number) => void;
  onOpenMeasurement?: (id: number) => void;
  hapticSelection: () => void;
  hapticSuccess: () => void;
};

export function CrmScheduleMeasurementBlock({
  leadId,
  onScheduled,
  onOpenMeasurement,
  hapticSelection,
  hapticSuccess,
}: Props) {
  const [city, setCity] = useState('');
  const [preferredTime, setPreferredTime] = useState('');
  const [notes, setNotes] = useState('');
  const [saving, setSaving] = useState(false);
  const [lastId, setLastId] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  const submit = async () => {
    if (!preferredTime.trim()) {
      setError('Выберите день и интервал выезда.');
      return;
    }
    hapticSelection();
    setSaving(true);
    setError(null);
    try {
      const res = await scheduleCrmLeadMeasurement(leadId, {
        city: city.trim() || undefined,
        preferred_time: preferredTime.trim(),
        notes: notes.trim() || undefined,
      });
      setLastId(res.measurement_id);
      hapticSuccess();
      onScheduled(res.measurement_id);
    } catch (err: unknown) {
      const ax = err as { response?: { data?: { detail?: string } } };
      setError(ax.response?.data?.detail || 'Не удалось создать заявку на замер');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="rounded-xl p-3 space-y-2"
      style={{ background: 'rgba(159,122,234,0.08)', border: '1px solid rgba(159,122,234,0.28)' }}
    >
      <p className="text-[11px] font-bold flex items-center gap-1.5" style={{ color: '#B794F4' }}>
        <Ruler size={14} /> Запись на замер
      </p>
      <p className="text-[10px] leading-relaxed" style={{ color: 'var(--text-3)' }}>
        Создаёт заявку в разделе «Замеры» и привязывает к лиду. Нужен телефон или Telegram ID в карточке.
      </p>
      <AdminMeasurementIntakeFields
        city={city}
        preferredTime={preferredTime}
        notes={notes}
        onCity={setCity}
        onPreferredTime={setPreferredTime}
        onNotes={setNotes}
        disabled={saving}
        onHaptic={hapticSelection}
      />
      {error && (
        <p className="text-[10px] px-2 py-1.5 rounded-lg" style={{ background: 'rgba(252,129,74,0.12)', color: '#FC814A' }}>
          {error}
        </p>
      )}
      <button
        type="button"
        disabled={saving}
        onClick={() => void submit()}
        className="press w-full py-2.5 rounded-xl text-xs font-bold touch-manipulation min-h-[44px]"
        style={{ background: 'rgba(159,122,234,0.2)', color: '#D6BCFA', border: '1px solid rgba(159,122,234,0.35)' }}
      >
        {saving ? '…' : 'Записать на замер'}
      </button>
      {lastId && onOpenMeasurement && (
        <button
          type="button"
          onClick={() => {
            hapticSelection();
            onOpenMeasurement(lastId);
          }}
          className="press w-full text-[10px] font-bold underline touch-manipulation"
          style={{ color: '#63B3ED' }}
        >
          Открыть замер #{lastId} в админке
        </button>
      )}
    </div>
  );
}
